"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AvatarSize = void 0;
const react_1 = __importDefault(require("react"));
const rebass_1 = require("rebass");
const styled_components_1 = __importDefault(require("styled-components"));
const Base = styled_components_1.default(rebass_1.Box) `
    border-radius: ${(props) => (props.rounded !== false ? "50%" : "0")};
    background: url(${(props) => props.url});
    background-repeat: no-repeat;
    background-position: center center;
    background-size: cover;
`;
var AvatarSize;
(function (AvatarSize) {
    AvatarSize["sm"] = "sm";
    AvatarSize["md"] = "md";
    AvatarSize["lg"] = "lg";
})(AvatarSize || (AvatarSize = {}));
exports.AvatarSize = AvatarSize;
const mapSize = (size) => ({
    [AvatarSize.sm]: {
        width: 30,
        height: 30,
    },
    [AvatarSize.md]: {
        width: 50,
        height: 50,
    },
    [AvatarSize.lg]: {
        width: 80,
        height: 80,
    },
}[size]);
const Avatar = (_a) => {
    var { size = AvatarSize.md, url } = _a, rest = __rest(_a, ["size", "url"]);
    return (react_1.default.createElement(Base, Object.assign({}, mapSize(size), { 
        // @ts-ignore
        url: url }, rest, { css: {} })));
};
exports.default = Avatar;
//# sourceMappingURL=index.js.map